import axios from "axios";
const BASE_URL = "https://mas.phvtech.com/api/Master/sp";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

export default axiosInstance;